export default "__VITE_ASSET__DAscr8YR__"